import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import _ from 'underscore';

import {
  AssetWithFoldersDataServiceProvider, useAsssetWithFoldersDataService
} from './asset-with-folders-data-service';

export const useAssetLibraryServices = useAsssetWithFoldersDataService;

export const withAssetLibraryServicesConsumer = (Page, pickedPropNames) => {
  const PageWithService = (props) => {
    const dataService = useAssetLibraryServices();
    // explicitly pick these props to keep pages' props clean
    let pickedProps = props;
    if (pickedPropNames) {
      pickedProps = _.pick(props, pickedPropNames);
    }
    return (<Page dataService={dataService} {...pickedProps} />);
  };

  hoistNonReactStatics(PageWithService, Page);

  return PageWithService;
};

export { AssetWithFoldersDataServiceProvider };
export { useFolders } from './use-folders';
export { VideoDataServiceProvider, useVideoDataService, withVideoDataService } from './video-data-service';
export { withCopilotDataServiceLoaded } from './copilot-data-service';
export { uploadVideoMetadata } from './video-metadata-util';
